import fetch from 'cross-fetch'
import getApiLocation from './getApiLocation'
import getDefaultHeaders from './getDefaultHeaders'
import validateResult from './validateResult'

const sendPostType = (action, { path, data }) => {
  const apiLocation = getApiLocation()

  return fetch(`${apiLocation}/${path}`, {
    method: action,
    headers: getDefaultHeaders(),
    body: JSON.stringify(data)
  })
    .then((res) => {
      if (res.status === 422) {
        // 422 is the server's business-rule refusal, whose message is written for the user.
        return res.json().catch(() => null).then(body => {
          validateResult(res, body)
          return body
        })
      }

      validateResult(res)
      return res.json()
    })
}

export default sendPostType
